import { render, staticRenderFns } from "./NFCGuideMask.vue?vue&type=template&id=1e1dbb07&scoped=true&"
import script from "./NFCGuideMask.vue?vue&type=script&lang=js&"
export * from "./NFCGuideMask.vue?vue&type=script&lang=js&"
import style0 from "./NFCGuideMask.vue?vue&type=style&index=0&id=1e1dbb07&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1dbb07",
  null
  
)

export default component.exports